import * as colours from 'colours';

const BORDER_SIZE = '20px';

export const rightRounded = {
  borderTopRightRadius: BORDER_SIZE,
  borderBottomRightRadius: BORDER_SIZE,
};

export const linearGradient = {
  background: `linear-gradient(to right, ${colours.APP_SECONDARY} -22%, ${colours.BLUISH} 44%, ${colours.BRIGHT_LIGHT_BLUE} 122%)`,
};
